export default "__VITE_ASSET__9593df85__"